import {Component, OnInit} from '@angular/core';
import {ConfirmationService, MessageService, SelectItem} from "primeng/api";
import {DialogService} from "primeng/dynamicdialog";
import {MagazzinoService} from "../../../services/magazzino.service";
import {ImpreseService} from "../../../services/imprese.service";
import {MagazzinoApiDescriptor, ModelloDispositivoApiDescriptor, MovimentazioneApiDescriptor, ScortaMaterialeApiDescriptor} from "../../../models/magazzino.model";
import {Impresa} from "../../../models/impresa.model";
import {RegioneDTO} from "../../../models/regione.model";
import {ActivatedRoute} from "@angular/router";
import {dateAsDDMMYYYY, datetimeAsHHMMSS, downloadXlsxWorkbook, exportDataToXlsx, getMagazzinoUserSummary, MagazzinoUserSummary} from "../../../lib/support";

@Component({
	selector: 'app-stato-scorte',
	templateUrl: './stato-scorte.component.html',
	styleUrls: ['./stato-scorte.component.scss'],
	providers: [DialogService, ConfirmationService],
})
export class StatoScorteComponent implements OnInit
{
	uiReady: boolean;
	dataReady: boolean;


	listingImprese: Impresa[];
	listingMagazzini: MagazzinoApiDescriptor[];
	listingMateriali: ModelloDispositivoApiDescriptor[];

	listingScorte: CompoStatoScortaMagazzino[];
	filteredScorte: CompoStatoScortaMagazzino[];

	optionsImpresa: SelectItem<Impresa>[];
	filterImpresa: Impresa;
	optionsMagazzino: SelectItem<MagazzinoApiDescriptor>[];
	filterMagazzino: MagazzinoApiDescriptor;
	optionsModelli: SelectItem<ModelloDispositivoApiDescriptor>[];
	filterModello: ModelloDispositivoApiDescriptor;

	optionsQuotaLessThan: SelectItem<number>[];
	filterQuotaLessThan: number;
	filterHasAny: boolean;

	lockMagazzino: string;
	lockImpresa: number;

	LEFT_BANDS = [75, 50, 25, 0];
	BANDS_COLORS = ["#0c71d9", "#0fab0f", "#ff8000", "#ff0000"];
	BANDS_FALLBACK = "#666666";

	userSummary: MagazzinoUserSummary;
	aziendaLockParam: number;

	constructor(
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		public dialogService: DialogService,
		private backendMagazzino: MagazzinoService,
		private impreseService: ImpreseService,
		private route: ActivatedRoute
	) {

		this.userSummary = getMagazzinoUserSummary();
		const canSeeAll = this.userSummary.isSmartFiber || this.userSummary.isPresidio || this.userSummary.isAdmin;
		this.aziendaLockParam = canSeeAll ? (this.route.snapshot.params["aziendaid"] ?? null) : this.userSummary.idImpresa;

		this.optionsImpresa = [];
		this.optionsMagazzino = [];
		this.filterImpresa = null;
		this.filterMagazzino = null;
		this.filterModello = null;
		this.filterHasAny = true;
		this.filterQuotaLessThan = null;

		const params = {...this.route.snapshot.params};
		if (params["magazzinoid"]) {
			console.log("filtering to magazzino: ", params["magazzinoid"])
			this.lockMagazzino = params["magazzinoid"];
		} else {
			// console.log("no filter by mag");
			this.lockMagazzino = null;
		}

		if (params["aziendaid"]) {
			console.log("filtering to azienda: ", params["aziendaid"])
			this.lockImpresa = parseInt(params["aziendaid"]);
		} else {
			// console.log("no filter by mag");
			this.lockImpresa = null;
		}


		this.optionsQuotaLessThan = [{
			label: "TUTTI",
			value: null
		}];
		for (let i = 0; i <= 1; i+=0.1) {
			const valueref =  1 - i;
			this.optionsQuotaLessThan.push({
				label: `${Math.round(valueref * 100)}%`,
				value: valueref
			});
		}

		this.listingScorte = [];
		this.filteredScorte = [];

		this.loadData();
	}

	ngOnInit() {
		this.uiReady = true;
	}

	loadData () {

		let impreseById = {};
		let materialiById = {};
		let magazziniById = {};

		let hashedScorteCorrenti: {[key: string]: ScortaMaterialeApiDescriptor} = {};
		let hashedScorteTotali: {[key: string]: ScortaMaterialeApiDescriptor} = {};

		const loaded = {
			magazzini:			false,
			imprese:			false,
			materiali:			false,
			scorte_correnti:	false,
			scorte_totali:		false,
		};

		const checkUpdateState = () => {
			if (Object.values(loaded).every((value) => value)) {
				this.listingScorte = Object.entries(hashedScorteCorrenti).map((item) => {
					const max_level = hashedScorteTotali[item[0]]?.balance ?? 0;
					const left_ratio = max_level != 0 ? item[1].balance / max_level : null;
					const left_perc = left_ratio != null ? Math.round(left_ratio * 100) : null;
					return {
						rif_azienda: item[1].rif_azienda,
						rif_magazzino: item[1].rif_magazzino,
						rif_modello: item[1].rif_modello,

						total_current: item[1].balance,
						total_max: max_level != 0 ? max_level : null,
						left_ratio: left_ratio,
						left_perc: left_perc,

						left_band_id: this.LEFT_BANDS.findIndex((thresh) => {
							return left_perc >= thresh;
						}),

						impresa: impreseById[`${item[1].rif_azienda}`] ?? {},
						magazzino: magazziniById[item[1].rif_magazzino] ?? {},
						modello: materialiById[item[1].rif_modello] ?? {}
					}
				});

				if (this.lockMagazzino != null) {
					this.filterMagazzino = magazziniById[this.lockMagazzino];
				}

				if (this.lockImpresa != null) {
					this.filterImpresa = impreseById[this.lockImpresa];
				}

				this.updateOptionsMagazzino();
				this.updateFiltered();
				this.dataReady = true;
			}
		}

		this.impreseService.get().subscribe((result: Impresa[]) => {
			this.listingImprese = result;
			impreseById = {};
			for (let item of result) {
				impreseById[`${item.id}`] = item;
			}
			loaded.imprese = true;
			this.optionsImpresa = [{
				label: "TUTTI",
				value: null
			}, ...this.listingImprese.map((item) => {
				return {
					label: item.ragioneSociale,
					value: item
				}
			})];
			checkUpdateState();
		});

		this.backendMagazzino.magazzinoList(this.aziendaLockParam).subscribe((result) => {
			this.listingMagazzini = result.listing;
			magazziniById = {};
			for (let item of result.listing) {
				magazziniById[`${item.id}`] = item;
			}
			loaded.magazzini = true;
			this.updateOptionsMagazzino();
			checkUpdateState();
		});

		this.backendMagazzino.modelloDispositivoList().subscribe((result) => {
			this.listingMateriali = result.listing;
			materialiById = {};
			for (let item of result.listing) {
				materialiById[`${item.id}`] = item;
			}
			this.optionsModelli = [{
				label: "TUTTI",
				value: null
			}, ...this.listingMateriali.map((item) => {
				return {
					label: `${item.nmu}: ${item.descrizione}`,
					value: item
				}
			})];
			loaded.materiali = true;
			checkUpdateState();
		});

		this.backendMagazzino.scorteCorrentiList(this.aziendaLockParam).subscribe((result) => {
			// console.log("scorte CORRENTI: ", result);
			hashedScorteCorrenti = {}
			for (let item of result.listing) {
				hashedScorteCorrenti[ item.rif_modello + "/" + item.rif_magazzino] = item;
			}
			loaded.scorte_correnti = true;
			checkUpdateState();
		});

		this.backendMagazzino.scorteTotaliList().subscribe((result) => {
			// console.log("scorte TOTALI: ", result)
			for (let item of result.listing) {
				hashedScorteTotali[ item.rif_modello + "/" + item.rif_magazzino] = item;
			}
			loaded.scorte_totali = true;
			checkUpdateState();
		});

	}

	updateOptionsMagazzino () {
		const optionable = this.listingMagazzini.filter((item) => {
			return this.filterImpresa == null || this.filterImpresa.id == item.azienda;
		}).sort((itemA, itemB) => {
			return itemA.codice.localeCompare(itemB.codice);
		});
		this.optionsMagazzino = [{
			label: "TUTTI",
			value: null
		}, ...optionable.map((item) => {
			return {
				label: item.codice,
				value: item
			};
		})];
		if (this.filterMagazzino != null && !optionable.some((item) => {
			return item.id == this.filterMagazzino.id;
		})) {
			this.filterMagazzino = null;
		}

	}

	updateFilterAzienda () {
		this.updateOptionsMagazzino();
		this.updateFiltered();
	}

	updateFiltered () {
		// console.log("filters: magazzino", this.filterMagazzino, "impresa", this.filterImpresa, "hasAny", this.filterHasAny, "quota", this.filterQuotaLessThan);
		this.filteredScorte = this.listingScorte.filter((item) => {
			return (this.filterMagazzino == null || item.rif_magazzino == this.filterMagazzino.id) &&
				(this.filterImpresa == null || item.rif_azienda == this.filterImpresa.id) &&
				(this.filterModello == null || item.rif_modello == this.filterModello.id) &&
				(this.filterHasAny == false || item.total_current > 0 || item.total_max > 0) &&
				(this.filterQuotaLessThan == null || (item.left_ratio != null && item.left_ratio < this.filterQuotaLessThan));
		});
	}


	downloadDataAsXlsx () {
		const sheet_name = "scorte_magazzini";
		const wb = exportDataToXlsx(
			["impresa", "magazzino", "nmu", "qt", "max"],
			this.filteredScorte.map((item) => {
				return {
					impresa: item.impresa.ragioneSociale,
					magazzino: item.magazzino.codice,
					nmu: item.modello.nmu,
					qt: item.total_current,
					max: item.total_max ?? null
				}
			}),{},sheet_name
		);

		const now = new Date();
		downloadXlsxWorkbook(wb, `${sheet_name}_${dateAsDDMMYYYY(now, "")}_${datetimeAsHHMMSS(now)}.xlsx`);

	}

}

export interface CompoStatoScortaMagazzino {
	rif_magazzino:		string;
	rif_azienda:		number;
	rif_modello:		string;

	total_current:		number;
	total_max:			number;

	left_ratio?:		number;
	left_perc?:			number;

	left_band_id:		number;

	impresa:			Impresa;
	magazzino:			MagazzinoApiDescriptor;
	modello:			ModelloDispositivoApiDescriptor;

}